/**
 * Reporting `error.message` instead of the error throws the stack trace away, which
 * leaves the resulting Sentry issue with no callsite. Keep the original whenever there
 * is one.
 */
export const toError = (value: unknown, fallbackMessage: string): Error => {
  if (value instanceof Error) {
    return value
  }

  if (typeof value === 'string' && value.length > 0) {
    return new Error(value)
  }

  return new Error(fallbackMessage)
}
